/** Cross-hook credit balance sync (PlanStatus pill, CreditProvider, dropdown). */

/** Sentinel balance written for admin / bypass accounts (BatchProcessing, useCreditSystem). */
export const BYPASS_CREDIT_BALANCE = 999_999;

export const CREDITS_UPDATED_EVENT = 'creditsUpdated';

export type CreditsUpdatedDetail = {
  /** Authoritative balance from RPC / DB. */
  newBalance?: number;
  /** Relative change (e.g. -0.5 after job refresh debit). */
  delta?: number;
};

/** Format credit count for the top-bar pill (never abbreviate real balances as ∞). */
export function formatCreditsForDisplay(
  count: number,
  options?: { loading?: boolean; unlimited?: boolean },
): string {
  if (options?.loading) return '…';
  if (!Number.isFinite(count)) return '—';
  if (options?.unlimited || count >= BYPASS_CREDIT_BALANCE) return 'Unlimited';
  const normalized = Math.round(count * 100) / 100;
  return Number.isInteger(normalized) ? String(normalized) : normalized.toFixed(1);
}

export function notifyCreditsChanged(detail: CreditsUpdatedDetail = {}): void {
  try {
    window.dispatchEvent(new CustomEvent<CreditsUpdatedDetail>(CREDITS_UPDATED_EVENT, { detail }));
  } catch {
    /* non-browser */
  }
}
